import {
  ArrowLeft,
  Facebook,
  Globe,
  Instagram,
  KeyRound,
  Mail,
  MessageCircle,
  MessageSquare,
  Phone,
  Send,
} from 'lucide-react';
import { Link } from 'react-router';
import { Badge } from '../../components/Badge';
import { CONNECT_CATALOG, type ConnectSlug } from '../../lib/channelMeta';
import './connect.css';

const SLUG_ICON: Record<ConnectSlug, typeof Mail> = {
  google: Mail,
  microsoft: Mail,
  'imap-smtp': KeyRound,
  ringcentral: Phone,
  whatsapp: MessageCircle,
  facebook: Facebook,
  instagram: Instagram,
  telegram: Send,
  twilio: MessageSquare,
  website: Globe,
};

export function ConnectPicker() {
  return (
    <main className="page">
      <Link to="/" className="back-link">
        <ArrowLeft size={14} />
        Channels
      </Link>
      <div className="page-head">
        <div>
          <h1 className="page-title">Connect a channel</h1>
          <p className="page-sub">Pick where your customers reach you.</p>
        </div>
      </div>
      <div className="connect-grid">
        {CONNECT_CATALOG.map((option) => {
          const Icon = SLUG_ICON[option.slug];
          return (
            <Link key={option.slug} to={`/connect/${option.slug}`} className="card connect-tile">
              <span className="channel-icon">
                <Icon size={17} />
              </span>
              <span className="connect-tile-text">
                <span className="connect-tile-label">{option.label}</span>
                <span className="connect-tile-desc">{option.description}</span>
              </span>
              <Badge tone={option.mode === 'oauth' ? 'accent' : 'neutral'}>
                {option.mode === 'oauth' ? 'Sign-in' : 'Credentials'}
              </Badge>
            </Link>
          );
        })}
      </div>
    </main>
  );
}
